module.exports = __webpack_public_path__ + "img/report_graphic2.9346684b.svg";